<template>
  <nav
    class="navbar navbar-main navbar-expand-lg px-0 ms-0 me-4 shadow-none border-radius-xl"
    :class="[
      this.$store.state.isRTL ? 'top-0 position-sticky z-index-sticky' : '',
      { 'navbar-theme-dark': this.$store.state.isDarkMode }
    ]"
    :style="this.$store.state.isDarkMode
      ? 'background: #1E293B !important; box-shadow: none !important;'
      : ''"
    v-bind="$attrs"
    id="navbarBlur"
    data-scroll="true"
  >
    <div class="py-1 pe-3 container-fluid d-flex align-items-center">
      <price-ticker class="ticker-in-nav" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4 flex-shrink-0" id="navbar">
        <ul class="navbar-nav justify-content-end ms-md-auto align-items-center flex-row">
          
          <!-- 👤 PŘIHLÁŠENÍ S HEZČÍM STRUKTUROVANÝM UTRAŽENÍM -->
          <li class="px-3 nav-item d-flex align-items-center login-nav-item">
            <a
              v-if="!isLoggedIn"
              class="nav-link font-weight-bold d-flex align-items-center nav-chip"
              :class="isDarkMode ? 'text-slate-200 chip-dark' : 'chip-light'"
              :style="userChipStyle"
              href="javascript:;"
              @click="toggleLoginForm"
            >
              <fa-icon class="me-2" icon="fa-solid fa-user" style="color: #FF8A4C;" />
              <span class="d-sm-inline d-none">Přihlásit se</span>
            </a>
            <a v-else
              class="nav-link font-weight-bold d-flex align-items-center nav-chip"
              :class="isDarkMode ? 'text-slate-200 chip-dark' : 'chip-light'"
              :style="userChipStyle"
              href="javascript:;"
              @click="$router.push({ name: 'Profil' })"
            >
              <fa-icon class="me-2 text-success" icon="fa-solid fa-user-check" />
              <span class="d-sm-inline d-none">{{ getUser?.UserNickName }}</span>
            </a>
          </li>

          <li v-if="isLoggedIn" class="px-2 nav-item d-flex align-items-center" >
            <router-link
              :to="{ name: 'Profil' }"
              class="nav-link d-flex align-items-center justify-content-center nav-icon-chip"
              :class="isDarkMode ? 'text-slate-200 chip-dark' : 'chip-light'"
              :style="iconChipStyle"
            >
              <fa-icon class="cursor-pointer fixed-plugin-button-nav" icon="fa-solid fa-cog" />
            </router-link>
          </li>

          <!-- Notifications (Zvoníček) -->
          <li class="nav-item dropdown d-flex align-items-center pe-3 notice-nav-item">
            <a
              href="#"
              class="nav-link d-flex align-items-center justify-content-center nav-icon-chip position-relative"
              :class="[showNotice ? 'show' : '', isDarkMode ? 'text-slate-200 chip-dark' : 'chip-light']"
              :style="iconChipStyle + 'transform:translateX(10px);'"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="showNotice = !showNotice"
            >
              <fa-icon class="notice-bell" icon="fa-solid fa-bell" />
              <span v-if="hasNotices" class="notice-dot" aria-hidden="true"></span>
            </a>
            <ul
              class="px-2 py-3 dropdown-menu dropdown-menu-end me-sm-n4 notice-dropdown"
              :class="[showNotice ? 'show' : '', isDarkMode ? 'notice-dropdown-dark' : '']"
              aria-labelledby="dropdownMenuButton"
            >
              <li v-for="(notice, noticeIndex) in Notice" :key="noticeIndex" class="mb-2" >
                <a 
                  class="dropdown-item border-radius-md notice-item" 
                  href="javascript:;"
                  @click.prevent="setNoticeAction(notice)"
                >
                  <div class="py-1 d-flex">
                    <div class="d-flex flex-column justify-content-center">
                      <h6 class="mb-1 text-sm font-weight-normal">
                        <span class="font-weight-bold" v-html="notice.Txt"></span>
                      </h6>
                      <p class="mb-0 text-xs text-secondary">
                        <fa-icon class="me-1" icon="fa-solid fa-clock" />
                        {{ notice.Dt }}
                      </p>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </li>

          <!-- 🌓 NOVÝ BURZOVNÍ PŘEPÍNAČ REŽIMŮ -->
          <li class="px-3 nav-item d-flex align-items-center justify-content-center theme-switch-item" style="gap: 6px; transform: translateX(10px);">
            <fa-icon
              icon="fa-solid fa-sun"
              :style="{ fontSize: '0.85rem', color: isDarkMode ? '#64748B' : '#ffb800' }"
            />
            <div class="form-check form-switch mb-0 ps-0 d-flex align-items-center">
              <input 
                class="form-check-input cursor-pointer" 
                type="checkbox" 
                role="switch" 
                id="themeModeToggleNavbar"
                style="width: 2.2rem; height: 1.1rem; margin-left: 0;"
                :checked="$store.state.isDarkMode"
                @change="toggleThemeMode"
              >
            </div>
            <fa-icon
              icon="fa-solid fa-moon"
              :style="{ fontSize: '0.8rem', color: isDarkMode ? '#E2E8F0' : '#94A3B8' }"
            />
          </li>

          <!-- 🟦 FB LINK (Vylepšená kostka) -->
          <li class="nav-item d-flex align-items-center ps-2 social-nav-item" style="gap: 10px; transform: translateX(15px);">
            <a
              class="nav-link social-nav-link"
              :class="isDarkMode ? 'text-slate-200 chip-dark' : 'chip-light'"
              :style="iconChipStyle"
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <fa-icon icon="fa-brands fa-facebook" />
            </a>
            <a
              class="nav-link social-nav-link"
              :class="isDarkMode ? 'text-slate-200 chip-dark' : 'chip-light'"
              :style="iconChipStyle"
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <fa-icon icon="fa-brands fa-instagram" />
            </a>
          </li>

          <!-- Hamburger pro mobily -->
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
              href="#"
              class="p-0 nav-link"
              :class="isDarkMode ? 'text-slate-200' : 'chip-light'"
              id="iconNavbarSidenav"
              @click="toggleSidebar"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line" :class="isDarkMode ? 'bg-white' : 'bg-dark'"></i>
                <i class="sidenav-toggler-line" :class="isDarkMode ? 'bg-white' : 'bg-dark'"></i>
                <i class="sidenav-toggler-line" :class="isDarkMode ? 'bg-white' : 'bg-dark'"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import PriceTicker from "../PriceTicker.vue";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  name: "navbar",
  data() {
    return {
      showNotice: false,
      reloadNoticeTimer: null
    };
  },
  props: ["minNav", "textWhite"],
  created() {
    this.minNav;
    this.loadNotice();
  },
  watch: {
    isLoggedIn() {
      if (this.isLoggedIn) {
        this.loadNotice();
        this.reloadNoticeTimer = setInterval(() => {
          this.loadNotice();
        }, 300000);
      } else {
        clearInterval(this.reloadNoticeTimer);
        this.loadNotice();
      }
    }
  },
  methods: {
    ...mapMutations(["navbarMinimize", "toggleConfigurator", "toggleLoginForm"]),
    ...mapActions(["toggleSidebarColor", "loadNotice", "fetchISINChartData", "loadOpenGameDetail"]),
    // --- NOVÁ METODA PRO UKLÁDÁNÍ A PŘEPÍNÁNÍ REŽIMU ---
    async toggleThemeMode(event) {
      const checkbox = event.target;
      const next = !!checkbox.checked;
      const ok = await this.$store.dispatch("setThemeMode", next);
      if (!ok) checkbox.checked = !!this.$store.state.isDarkMode;
    },

    toggleSidebar() {
      this.toggleSidebarColor("bg-white");
      this.navbarMinimize();
    },
    resolveNoticeAction(notice) {
      if (notice == null) return "";
      if (typeof notice !== "object") return String(notice);
      const act = String(notice.Act || "").trim();
      const eid = notice.Eid || notice.EntityID;
      const ctx = Number(notice.Ctx || notice.ContextID);
      const typ = String(notice.Typ || notice.NoticeType || "");

      if (typ === "NT_I" || ctx === 1003 || act.startsWith("ISINID_")) {
        const isinId = act.startsWith("ISINID_") ? act.slice(7) : eid;
        return isinId ? ("ISINID_" + isinId) : "";
      }
      if (act.startsWith("OPEN_")) return act;
      if (typ === "NT_G" && eid && (!act || act === "MYINGA")) {
        return "OPEN_" + eid;
      }
      return act;
    },
    setNoticeAction(notice) {
      this.showNotice = false;
      const action = this.resolveNoticeAction(notice);
      if (!action) return;

      if (action === "PROFILE") {
        this.$router.push("/profil");
      } else if (action === "MYINGA") {
        this.$router.push("/moje-inga");
      } else if (action.startsWith("REWARD_")) {
        this.$store.dispatch("loadRewardDetail", action.split("_")[1]);
      } else if (action.startsWith("OPEN_")) {
        this.loadOpenGameDetail(action.split("_")[1]);
      } else if (action.startsWith("GAME_")) {
        this.$router.push({ name: "Běžící hra", params: { gid: action.split("_")[1] } });
      } else if (action.startsWith("ISINID_")) {
        this.fetchISINChartData(action.split("_")[1]);
      }
    }
  },
  components: {
    PriceTicker
  },
  computed: {
    isDarkMode() {
      return !!this.$store.state.isDarkMode;
    },
    hasNotices() {
      const notices = this.Notice;
      if (!notices) return false;
      if (Array.isArray(notices)) return notices.length > 0;
      if (typeof notices === "object") return Object.keys(notices).length > 0;
      return false;
    },
    userChipStyle() {
      const size = "height:34px;max-height:34px;padding:0 12px;line-height:1;overflow:hidden;box-sizing:border-box;display:flex;align-items:center;";
      if (this.isDarkMode) {
        return size + "background-color:#0F172A;border:1px solid #334155;font-size:0.8rem;";
      }
      return size + "background-color:#FFFFFF;border:1px solid #E2E8F0;color:#0F172A;font-size:0.8rem;";
    },
    iconChipStyle() {
      if (this.isDarkMode) {
        return "background-color: #0F172A; border: 1px solid #334155;";
      }
      return "background-color: #FFFFFF; border: 1px solid #E2E8F0; color: #0F172A;";
    },
    ...mapState(['Notice']),
    ...mapGetters([
      'isLoggedIn',
      'getUser'
    ])
  }
};
</script>


<style scoped>
/* Sjednocení výšky a zarovnání všech prvků v liště */
.navbar-nav {
  align-items: center !important;
}

.navbar.navbar-main {
  margin-left: 0 !important;
}

:deep(.price-ticker) {
  min-width: 0;
}

:deep(.ticker-in-nav) {
  margin-right: calc(1rem - 13px);
}

.login-nav-item .nav-chip {
  transform: translateX(5px);
}

.notice-nav-item > .nav-icon-chip {
  transform: translateX(10px);
}

.nav-chip,
.nav-icon-chip,
.social-nav-link {
  box-sizing: border-box;
  height: 34px !important;
  min-height: 34px;
  max-height: 34px;
  border-radius: 12px !important;
  line-height: 1;
}

.nav-chip {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 0.85rem !important;
}

.nav-icon-chip,
.social-nav-link {
  width: 34px;
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
}

.notice-dot {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #EF4444;
  border: 2px solid #ffffff;
  z-index: 20;
  display: block;
  flex-shrink: 0;
  pointer-events: none;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.25);
}

.navbar-theme-dark .notice-dot {
  border-color: #1E293B;
}

.notice-bell,
.notice-bell :deep(svg) {
  color: #0F172A;
  fill: currentColor;
}

.navbar-theme-dark .notice-bell,
.navbar-theme-dark .notice-bell :deep(svg) {
  color: #CBD5E1 !important;
  fill: #CBD5E1 !important;
}

.navbar-theme-dark .notice-nav-item .nav-icon-chip {
  background-color: #0F172A !important;
  border-color: #334155 !important;
  color: #CBD5E1 !important;
}

.notice-dropdown-dark {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.4) !important;
}

.notice-item {
  cursor: pointer;
}

.notice-dropdown-dark .dropdown-item {
  color: #E2E8F0 !important;
}

.notice-dropdown-dark .dropdown-item:hover,
.notice-dropdown-dark .dropdown-item:focus {
  background: #1E293B !important;
}

.notice-dropdown-dark h6,
.notice-dropdown-dark .font-weight-bold {
  color: #E2E8F0 !important;
}

.notice-dropdown-dark .text-secondary {
  color: #94A3B8 !important;
}

.nav-chip :deep(svg),
.nav-icon-chip :deep(svg),
.social-nav-link :deep(svg) {
  width: 0.9rem;
  height: 0.9rem;
}

/* Úprava ikon sociálních sítí do odlehčeného burzovního stylu */
.social-nav-link {
  background-color: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s ease;
}

.social-nav-link:hover {
  background-color: rgba(255, 255, 255, 0.18);
  transform: translateY(-1px);
}

.chip-dark:hover {
  background-color: #334155 !important;
  border-color: #475569 !important;
}

.chip-light {
  color: #0F172A !important;
}

.chip-light:hover {
  background-color: #F8FAFC !important;
  border-color: #CBD5E1 !important;
}

.text-slate-200 {
  color: #E2E8F0 !important;
}

/* Vychytávka pro stylování Bootstrap switch přepínače v navbaru */
.theme-switch-item .form-switch .form-check-input {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://w3.org' viewBox='0 0 20 20'%3e%3cpath fill='rgba%28255, 255, 255, 0.6%29' d='M5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0z'/%3e%3c/svg%3e");
  background-color: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  transition: background-position 0.2s ease-in-out, background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
}

.theme-switch-item .form-switch .form-check-input:checked {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://w3.org' viewBox='0 0 20 20'%3e%3cpath fill='%23fff' d='M5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0z'/%3e%3c/svg%3e");
  background-color: #ff7a00 !important;
  border-color: #ff4d00 !important;
}

.navbar-theme-dark .theme-switch-item .form-switch .form-check-input {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://w3.org' viewBox='0 0 20 20'%3e%3cpath fill='%2394A3B8' d='M5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0z'/%3e%3c/svg%3e");
  background-color: #0F172A !important;
  border: 1px solid #334155 !important;
}

.navbar-theme-dark .theme-switch-item .form-switch .form-check-input:checked {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://w3.org' viewBox='0 0 20 20'%3e%3cpath fill='%23E2E8F0' d='M5 10a5 5 0 1 1 10 0 5 5 0 0 1-10 0z'/%3e%3c/svg%3e");
  background-color: #334155 !important;
  border-color: #475569 !important;
}

.theme-switch-item .form-switch .form-check-input:focus {
  box-shadow: none;
}

/* Pomocné barevné třídy pro moderní vzhled */
.text-slate-400 {
  color: #94a3b8 !important;
}
.text-warning {
  color: #ffb800 !important;
}
</style>

<style>
.navbar-main .navbar-nav > .nav-item > .nav-link.nav-chip,
.navbar-main .navbar-nav > .nav-item > .nav-link.nav-icon-chip,
.navbar-main .navbar-nav > .nav-item > a.social-nav-link {
  height: 34px !important;
  min-height: 34px !important;
  max-height: 34px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 1 !important;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: center !important;
}
.navbar-main .navbar-nav > .nav-item > .nav-link.nav-chip {
  padding-left: 12px !important;
  padding-right: 12px !important;
  overflow: hidden !important;
}
.navbar-main .navbar-nav > .nav-item > .nav-link.nav-icon-chip,
.navbar-main .navbar-nav > .nav-item > a.social-nav-link {
  width: 34px !important;
  justify-content: center !important;
  overflow: visible !important;
  position: relative !important;
}
.navbar-main .navbar-nav > .notice-nav-item > .nav-icon-chip {
  transform: translateX(10px) !important;
}
.navbar-main .navbar-nav > .social-nav-item {
  transform: translateX(15px) !important;
}
.navbar-main .navbar-nav > .theme-switch-item {
  transform: translateX(10px) !important;
}
.navbar-main .notice-dot {
  position: absolute !important;
  top: 3px !important;
  right: 3px !important;
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
  background: #EF4444 !important;
  border: 2px solid #ffffff !important;
  z-index: 30 !important;
  display: block !important;
  pointer-events: none !important;
}
@media (max-width: 430px) {
  .navbar-main .navbar-nav > .social-nav-item {
    display: none !important;
  }
  .navbar-main .navbar-nav > .login-nav-item {
    padding-left: 0.35rem !important;
    padding-right: 0.35rem !important;
  }
  .navbar-main .navbar-nav > .notice-nav-item > .nav-icon-chip,
  .navbar-main .navbar-nav > .theme-switch-item {
    transform: none !important;
  }
  .navbar-main .nav-item.d-xl-none {
    padding-left: 0.5rem !important;
  }
}

.navbar-main.navbar-theme-dark .notice-dot,
body.inga-theme-dark .navbar-main .notice-dot {
  border-color: #1E293B !important;
}
.navbar-main.navbar-theme-dark .notice-nav-item .notice-bell,
.navbar-main.navbar-theme-dark .notice-nav-item .notice-bell svg,
body.inga-theme-dark .navbar-main .notice-nav-item .notice-bell,
body.inga-theme-dark .navbar-main .notice-nav-item .notice-bell svg {
  color: #CBD5E1 !important;
  fill: #CBD5E1 !important;
}
</style>

